// extracted by mini-css-extract-plugin
module.exports = {"pageProduct":"product_pageProduct__wP0m3"};